
export function getClaimRoom(tenant: string, jobId: string) {
    return `${tenant}/claims/${jobId}`;
}